import React, { useState, useRef, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import DanhSachThanhLyApi from "service/danhSachThanhLyApi";
import ReactToPrint from "react-to-print";

export const BtnInPhieuThanhLy = ({ thanhLyId }) => {
  const scrollRef = useRef();
  const dataIn = {
    printContent: "",
  };
  const [dataInThu, UpdateDataInThu] = useState(dataIn);

  const InPhieuThu = () => {
    DanhSachThanhLyApi.getInThanhToanThanhLyTaiSan(thanhLyId).then(
      (response) => {
        UpdateDataInThu({
          ...dataInThu,
          printContent: response.data,
        });
      }
    );
  };

  useEffect(() => {
    InPhieuThu();
  }, []);
  const ComponentToPrint = React.forwardRef((props, ref) => (
    <div
      className="col-sm-12"
      style={{ width: "100%", color: "#000000" }}
      ref={ref}
    >
      <div
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{ __html: props.data }}
      ></div>
    </div>
  ));
  return (
    <>
      <ReactToPrint
        trigger={() => {
          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
          // to the root node of the returned component as it will be overwritten.
          return (
            <a href={() => false}>
              <PopoversBootrap
                contentText="In phiếu thanh lý"
                trigger={["hover", "focus"]}
                placement={"top"}
              >
              <img src="/app-assets/images/icon-in-danh-sach.png" />
              </PopoversBootrap>
            </a>
          );
        }}
        content={() => scrollRef.current}
        copyStyles={false}
      />

      <div style={{ display: "none" }}>
        <ComponentToPrint data={dataInThu.printContent} ref={scrollRef} />
      </div>
    </>
  );
};
